export default {
  namespaced: true,
  state: {
    drawer: {
      model: null,
      type: "default (no property)",
      dense: false,
      clipped: true,
      floating: false,
      mini: true,
    },
    routes: [{
      path: "/",
      name: "Dashboard",
      icon: "mdi-monitor-dashboard",
      rule: "isLogged",
    },
    {
      name: "Konseling",
      icon: "mdi-message-text",
      childs: [{
        path: "/konseling",
        name: "Diskusi",
        icon: "mdi-message-text-outline",
        rule: "isLogged",
      },
      {
        path: "/kategori-konseling",
        name: "Kategori",
        icon: "mdi-shape",
        rule: "isSpitda",
      },
      {
        path: "/label-konseling",
        name: "Label",
        icon: "mdi-label-outline",
        rule: "isSpitda",
      },
      ],
    },
    {
      name: "Laporan",
      icon: "mdi-bookshelf",
      childs: [{
        path: "/laporan/rkas",
        name: "RKAS",
        icon: "mdi-notebook",
        rule: "isLogged",
      },
      {
        path: "/transaksi",
        name: "Transaksi",
        icon: "mdi-chart-timeline-variant",
        rule: "isLogged",
      },
      {
        path: "/laporan/sp2b",
        name: "SP2B",
        icon: "mdi-calendar-check-outline",
        rule: "isLogged",
      },
      {
        path: "/laporan/realisasi",
        name: "Realisasi Dana BOS",
        icon: "mdi-text-box-check",
        rule: "isLogged",
      },
      {
        path: "/laporan/bosnas",
        name: "Bosnas",
        icon: "mdi-briefcase-variant",
        rule: "isLogged",
      },
      {
        path: "/laporan/bosda",
        name: "Bosda",
        icon: "mdi-briefcase-variant",
        rule: "isLogged",
      },

      ],
    },
    {
      name: "Data Dasar",
      icon: "mdi-wall",
      rule: "isAdmin",
      childs: [{
        path: "/bidang",
        name: "Bidang",
        icon: "mdi-folder-outline",
        rule: "isAdmin",
      },
      {
        path: "/kegiatan",
        name: "Kegiatan",
        icon: "mdi-run",
        rule: "isAdmin",
      },
      {
        path: "/pajak",
        name: "Pajak",
        icon: "mdi-cash",
        rule: "isAdmin",
      },
      // {
      //   path: "/lokasi",
      //   name: "Lokasi",
      //   icon: "mdi-map-marker",
      // },
      {
        path: "/pejabat",
        name: "Pejabat",
        icon: "mdi-briefcase-account-outline",
        rule: "isAdmin",
      },
      {
        path: "/program",
        name: "Program",
        icon: "mdi-briefcase-outline",
        rule: "isAdmin",
      },
      {
        path: "/rekening",
        name: "Rekening",
        icon: "mdi-badge-account-horizontal",
        rule: "isAdmin",
      },
      {
        path: "/sekolah",
        name: "Sekolah",
        icon: "mdi-bag-personal",
        rule: "isAdmin",
      },
      {
        path: "/status-anggaran",
        name: "Status Anggaran",
        icon: "mdi-label-variant-outline",
        rule: "isAdmin",
      },
      {
        path: "/tahun",
        name: "Tahun",
        icon: "mdi-calendar",
        rule: "isAdmin",
      },
      {
        path: "/urusan",
        name: "Urusan",
        icon: "mdi-briefcase-variant",
        rule: "isAdmin",
      },
      {
        path: "/master/silpa",
        name: "Silpa",
        icon: "mdi-briefcase-variant",
        rule: "isAdmin",
      },

      ],
    },
    {
      name: "Pengaturan",
      icon: "mdi-cogs",
      rule: "isLogged",
      childs: [{
        path: "/pengaturan/pengguna",
        name: "Pengguna",
        icon: "mdi-account-settings",
        rule: "isAdmin",
      },
      {
        path: "/pengaturan/grup",
        name: "Grup",
        icon: "mdi-account-multiple",
        rule: "isSuperAdmin",
      },
      {
        path: "/pengaturan/profil",
        name: "Profil",
        icon: "mdi-wrench",
        rule: "isLogged"
      },
      ],
    },
    ],
  },
  mutations: {},
  actions: {},
  getters: {},
};